import React from 'react'

function FailedApiErrorPopup({ setOpenPopup, viewErrorMsg, setClick }) {
    return (
        <div className="published_Deative_transprant_body" style={{ zIndex: "999" }}>
            <div className="published_Deative_preview_container">
                <div className="col-12 deactivate_msg" style={{ fontSize: "18px", whiteSpace: "pre-line", lineHeight: "1.5" }}>
                    {viewErrorMsg}
                </div>
                <div className="row col-12 publish_deactive_btnBox" style={{ width: "300px" }}>
                    <button className="btn col-sm-5 my-1 deactive_sure_btn" onClick={() => {
                        setClick(false)
                        setOpenPopup(false)
                    }}>
                        Okay
                    </button>
                </div>
            </div>
        </div>
    )
}

export default FailedApiErrorPopup